/**
 * Created by or_p on 6/21/2016.
 */
import React, { PureComponent } from 'react';
import * as Colors from 'material-ui/styles/colors';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';

export default class CustomWidthAndHeight extends PureComponent {
  constructor(props) {
    const {defaultHeight, defaultWidth, initialAspectRatio} = props;
    super();
    this.state = {
      aspectRatio: initialAspectRatio,
      height: defaultHeight,
      width: defaultWidth,
    };
  }

  componentWillReceiveProps(nextProps) {
    const stateUpdate = {};
    if (this.props.initialAspectRatio !== nextProps.initialAspectRatio) {
      stateUpdate.aspectRatio = nextProps.initialAspectRatio;
    }
    if (this.props.defaultHeight !== nextProps.defaultHeight) {
      stateUpdate.height = nextProps.defaultHeight;
    }
    if (this.props.defaultWidth !== nextProps.defaultWidth) {
      stateUpdate.width = nextProps.defaultWidth;
    }
    this.setState(stateUpdate);
  }

  componentDidUpdate(prevProps, prevState) {
    const {onChange} = this.props;
    const {width, height} = this.state;
    if (width !== prevState.width || height !== prevState.height) {
      if (onChange) {
        onChange({width, height});
      }
    }
  }

  onWidthChange = (event) => {
    const {aspectRatio} = this.state;
    const newState = {};
    newState.width = parseInt(event.target.value, 10);
    if (isNaN(newState.width)) {
      newState.width = 0;
    }
    if (aspectRatio) {
      newState.height = Math.round(newState.width / aspectRatio);
    }
    this.setState(newState);
  };


  onHeightChange = (event) => {
    const {aspectRatio} = this.state;
    const newState = {};
    newState.height = parseInt(event.target.value, 10);
    if (isNaN(newState.height)) {
      newState.height = 0;
    }
    if (aspectRatio) {
      newState.width = Math.round(newState.height * aspectRatio);
    }
    this.setState(newState);
  };

  getWidth() {
    return this.state.width;
  }

  getHeight() {
    return this.state.height;
  }

  getAspectRatio() {
    return this.state.aspectRatio;
  }

  toggleAspectRatioLock = () => {
    let aspectRatio;
    if (this.state.aspectRatio) {
      aspectRatio = false;
    } else {
      aspectRatio = this.getWidth() / this.getHeight();
    }
    this.setState({aspectRatio});
  };

  render() {
    const {defaultHeight, defaultWidth, disabled, style, label} = this.props;
    const {aspectRatio} = this.state;
    let {height, width} = this.state;
    if (disabled || !height) {
      height = defaultHeight;
    }
    if (disabled || !width) {
      width = defaultWidth;
    }
    const iconColor = disabled ? Colors.grey200 : Colors.grey700;
    return (
      <div
        style={{fontSize: '16px', display: 'flex', alignItems: 'center', ...style}}
      >
        <span
          style={{paddingRight: 10}}
        >
          {label}
        </span>
        <TextField
          style={{width: 50}}
          hintText="Width"
          disabled={disabled}
          ref="width"
          inputStyle={{textAlign: 'center'}}
          value={width}
          onChange={this.onWidthChange}
        />
        <IconButton
          disabled={disabled}
          onClick={this.toggleAspectRatioLock}
          tooltip={aspectRatio ? 'Unlock Aspect Ratio' : 'Lock Aspect Ratio'}
          touch
          tooltipPosition="top-center"
        >
          {
            aspectRatio ?
              <AspectLockIcon color={iconColor}/> :
              <AspectUnLockIcon color={iconColor}/>
          }
        </IconButton>
        <TextField
          style={{width: 50}}
          hintText="Height"
          disabled={disabled}
          ref="height"
          inputStyle={{textAlign: 'center'}}
          value={height}
          onChange={this.onHeightChange}
        />
      </div>
    );
  }
}

CustomWidthAndHeight.defaultProps = {
  label: 'Image Size:',
};

class AspectLockIcon extends PureComponent {
  render() {
    return (<SvgIcon>
      <path fill={this.props.color || this.props.style.color} d="M16,6H13V7.9H16C18.26,7.9 20.1,9.73 20.1,12A4.1,4.1 0 0,1 16,16.1H13V18H16A6,6 0 0,0 22,12C22,8.68 19.31,6 16,6M3.9,12C3.9,9.73 5.74,7.9 8,7.9H11V6H8A6,6 0 0,0 2,12A6,6 0 0,0 8,18H11V16.1H8C5.74,16.1 3.9,14.26 3.9,12M8,13H16V11H8V13Z" />
    </SvgIcon>);
  }
}

class AspectUnLockIcon extends PureComponent {
  render() {
    return (<SvgIcon>
      <path fill={this.props.color || this.props.style.color} d="M2,5.27L3.28,4L20,20.72L18.73,22L14.73,18H13V16.27L9.73,13H8V11.27L5.5,8.76C4.5,9.5 3.9,10.68 3.9,12C3.9,14.26 5.74,16.1 8,16.1H11V18H8A6,6 0 0,1 2,12C2,10.16 2.83,8.5 4.14,7.41L2,5.27M16,6A6,6 0 0,1 22,12C22,14.21 20.8,16.15 19,17.19L17.6,15.77C19.07,15.15 20.1,13.7 20.1,12C20.1,9.73 18.26,7.9 16,7.9H13V6H16M8,6H11V7.9H9.72L7.82,6H8M16,11V13H14.82L12.82,11H16Z"/>
    </SvgIcon>);
  }
}
